<template>
  <div class="modal-container" @click="handleOutsideClick()"
    :style="{justifyContent: getJustifyPosition, alignItems: getAlignPosition}"
    v-if="showModalWindow">
    <div @click.stop class="modal-content">
      <button class="modal-dismiss" v-if="enableCloseIcon" @click="onClose(!show)">
        <img class="close-icon" src="@/assets/images/close.svg">
      </button>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

// Define component options
defineOptions({
  name: 'modal'
});

// Define props
const props = defineProps({
  show: { type: Boolean, required: true },
  enableCloseIcon: { type: Boolean, required: false, default: true },
  onClose: { type: Function, default: () => {} },
  position: {
    type: String,
    // Naming convention means VerticalPositing-HorizontalPositing
    enum: [
      'top-left',
      'top-center',
      'top-right',
      'center-left',
      'center-center',
      'center-right',
      'bottom-left',
      'bottom-center',
      'bottom-right'
    ],
    default: 'center-center'
  },
  disableOutsideClick: { type: Boolean, default: false },
  disableEscapeKey: { type: Boolean, default: false }
});

// Reactive data
const showModalWindow = ref(props.show);

// Computed properties
const getJustifyPosition = computed(() => {
  const position = props.position.split('-')[1];
  if (position === 'center') {
    return 'center';
  }
  if (position === 'left') {
    return 'flex-start';
  }
  if (position === 'right') {
    return 'flex-end';
  }
});

const getAlignPosition = computed(() => {
  const position = props.position.split('-')[0];
  if (position === 'center') {
    return 'center';
  }
  if (position === 'top') {
    return 'flex-start';
  }
  if (position === 'bottom') {
    return 'flex-end';
  }
});

// Methods
const handleEscKey = (modalState) => {
  if (props.disableEscapeKey) {
    return;
  }

  const handler = () => props.onClose(false);
  if (modalState) {
    document.body.addEventListener('keyup', handler, false);
  }
  if (!modalState) {
    document.body.removeEventListener('keyup', handler, false);
  }
};

const handleOutsideClick = () => {
  if (!props.disableOutsideClick) {
    props.onClose(false);
  }
};

// Watchers
watch(() => props.show, (newValue) => {
  if (newValue !== showModalWindow.value) {
    showModalWindow.value = newValue;
  }
  
  handleEscKey(newValue);
});
</script>
<style scoped>
.modal-container {
  display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(255,255,255,0.5);
    padding: 10px;
    box-sizing: border-box;
    z-index: 9999;
    
    @media (max-width: 996px) {
        justify-content: center;
        align-items: center;
        width: 100%;
    }
}
  .close-icon {
    height: 15px;
    @media screen and (max-width: 768px) {
      border-radius: 30%;
    }
  }
  .modal-content {
    width: 80%;
    min-height: 100px;
    background: #fff;
    opacity: 1;
    box-shadow: 0px 0px 7px 1px rgba(0, 0, 0, 0.1);
    border: 1px solid #000;
    box-sizing: border-box;
    padding: 40px 30px;
    position: relative;
    @media screen and (max-width: 768px) {
        max-height: 90%;
        overflow-y: auto;
        padding: 40px 15px 15px 15px;
    }
  }
  .modal-dismiss {
    border: 0;
    background: none;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        top: 12px;
        right: 8px;
    }
  }
</style>